import { createAxiosInstance } from "./index";
import hostConfig from "@/config/hostResolver";

const baseUrl =
  process.env.VUE_APP_COMMUNICATIONS_URL ?? `${hostConfig.apiBaseUrl}/communications-service`;

class CommunicationService {
  constructor() {
    this.apiClient = createAxiosInstance(baseUrl);
  }

  // V3 routes
  getPopupMessagesV3(params) {
    return this.apiClient
      .get(baseUrl + "/v3/message/activity/popup", { params })
      .then((response) => {
        return response.data.result;
      })
      .catch((error) => {
        console.log("error getting popup messages ", error?.response || error);
        throw error?.response || error;
      });
  } // getPopupMessagesV3

  getMessagesV3(params, filterString) {
    return this.apiClient
      .get(baseUrl + "/v3/message/activity/" + filterString, { params: params })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("error ", error.response);
        throw error.response;
      });
  }
}

export default CommunicationService;
